import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/images/treatments-background.webp"
          alt="Ayurvedic Wellness Background"
          className="w-full h-full object-cover"
        />
        {/* Semi-transparent overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/70 to-background/60"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        <div className="glass-card p-8 lg:p-12 morph-hover">
          <div className="inline-flex items-center justify-center w-20 h-20 glass-panel rounded-full mb-6 morph-3d">
            <Icon name="MessageCircle" size={32} className="text-tertiary" />
          </div>

          <h1 className="font-headline text-4xl lg:text-6xl font-bold text-primary mb-6">
            Get in Touch
          </h1>

          <p className="text-lg lg:text-xl text-tertiary max-w-2xl mx-auto leading-relaxed">
            Ready to begin your healing journey through Ayurveda? Connect with our experienced physicians to understand your condition and receive a personalized, root-cause–based treatment plan.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <div className="glass-panel px-6 py-3 rounded-full morph-hover">
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={18} className="text-primary" />
                <span className="text-sm font-medium">Open Today 8AM - 7PM</span>
              </div>
            </div>
            {/* <div className="glass-panel px-6 py-3 rounded-full morph-hover">
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={18} className="text-primary" />
                <span className="text-sm font-medium">Downtown Beauty District</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;